const getWidgetId = (formId) => {
  const recaptchaContainer = document.querySelector(
    `[data-recaptcha-container][data-form-id="${formId}"]`
  );
  return recaptchaContainer.dataset.widgetId;
};

export const recaptchaValidator = (inputElem, callback) => {
  const widgetId = getWidgetId(inputElem.dataset.formId);

  // `.getResponse()` returns a string of length >= 1 if valid, otherwise
  // a string of length 0 if invalid.
  const valid = window.grecaptcha.getResponse(widgetId);
  if (valid) {
    return callback('');
  }

  window.grecaptcha.execute(widgetId);
  return callback('Please complete the reCAPTCHA.');
};

const recaptchaSuccessCallback = (formId) => {
  const formElem = document.getElementById(formId);

  const event = new Event('submit', {
    bubbles: true,
    cancelable: true
  });
  formElem.dispatchEvent(event);
};

export const initializeRecaptchas = () => {
  const recaptchaContainers = document.querySelectorAll(
    '[data-recaptcha-container]'
  );

  recaptchaContainers.forEach((container) => {
    const widgetId = window.grecaptcha.render(container, {
      sitekey: container.dataset.sitekey,
      size: 'invisible',
      callback: () => {
        recaptchaSuccessCallback(container.dataset.formId);
      }
    });

    container.dataset.widgetId = widgetId;
  });
};
